// src/components/MonthSelector.js
import React from "react";
import Logo from "./Logo"; // Import the Logo component

function MonthSelector({ selectedMonth, setSelectedMonth, startGame }) {
  const months = Object.keys(require("../data/words").wordsByMonth);

  return (
    <div className="text-center">
      <Logo w="120px" link="https://games.onlineplanning.xyz" />

      <h1 className="text-3xl font-bold mb-4">
        Welcome to the CECI Word Game!
      </h1>
      <select
        className="border rounded p-2 mb-4 text-3xl outline outline-red-500"
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(e.target.value)}
      >
        <option value="" disabled>
          Select a Month
        </option>
        {months.map((month) => (
          <option key={month}>{month}</option>
        ))}
      </select>
      <br />
      <button
        className="bg-red-700 text-white px-8 py-4 rounded font-semibold text-2xl disabled:bg-red-300"
        onClick={startGame}
        disabled={!selectedMonth}
      >
        Start Game
      </button>
    </div>
  );
}

export default MonthSelector;
